var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFire = function SvgIcFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_fire_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.926 4.373c.143.955.31 1.502-.374 1.502-.93 0-.93-2.2-2.503-3.453-1.556-1.24-2.717-.939-2.742-.932l-.001.001c1.296 1.083.573 2.861-.275 3.352-.814.47-1.744-.123-1.257-1.52C2.704 4.788 1.78 6.56 1.78 8.327a5.219 5.219 0 0 0 10.438 0c0-1.362-.55-2.728-1.292-3.953Z",
    fill: "#EF4452"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.999 7.506s2.27 1.307 2.27 3.133a2.27 2.27 0 1 1-4.54 0C4.73 8.813 7 7.506 7 7.506Z",
    fill: "#FF7978"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_fire_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgIcFire;